export default __webpack_public_path__ + "static/media/ud-trucks.ae7d23d6.svg";